import { Person } from 'types/personTypes';

export const createPerson = (): Person => ({
  firstName: '',
  lastName: '',
  middleName: '',
  phone: '',
});

export const createPersonMock = (): Person => ({
  firstName: 'Иван',
  lastName: 'Иванов',
  middleName: 'Иванович',
  phone: '+375 44 343 78 91',
});
